/**
* web
*/

import '@common/polyfill/src/promise'
import cookies from 'js-cookie'
import urlTool from '@common/url'
import domain from '@common/domain'
import useragent from '@common/useragent'

import BaseAuth from './base'

class WebAuth extends BaseAuth {
  constructor(options) {
    super(options)
    if (!useragent.isSuishouji && !useragent.isSuiguanjia && !useragent.isKaniu && !useragent.isYunzhijia) {
      this.isClientHit = true
    }
  }
  // 获取token
  getToken() {
    if (!this.isClientHit) return undefined
    return Promise.resolve({})
  }
  // 登录
  login() {
    if (!this.isClientHit) return
    if (this.loginType.silent || this.checkIsLogin()) {
      // 如果是静默登录，或已登录，支持后续事件
      this.requestLoginApiSuccessCallback()
    } else {
      let queryStr = ''
      if (this.accountType.acc) {
        queryStr = 'accountType=acc'
      } else if (this.accountType.custody) {
        queryStr = 'accountType=custody'
      }
      cookies.set('success_forwardUrl', this.options.forwardUrl, { domain: urlTool('domain') })
      window.location.href = `${domain.res}/public-vue/common/index.html#/login${queryStr ? ('?' + queryStr) : ''}`
    }
  }
}

export default WebAuth



// WEBPACK FOOTER //
// ./node_modules/@finance/login/src/client/web.js